import { render, staticRenderFns } from "./activityStatusesTable.vue?vue&type=template&id=b5ca32e0"
import script from "./activityStatusesTable.vue?vue&type=script&lang=js"
export * from "./activityStatusesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports